import React from 'react'
import iconSet from '../../assets/icon/selection.json'
import IcomoonReact from 'icomoon-react'

const Icon = ({ ...props }) => <IcomoonReact iconSet={iconSet} {...props} />

export default Icon
